const renderAgenda = (props) => {

  if(props.row.DocumentNumber!==''){

   return (
      <a  href={props.row.DocumentNumber} target='_blank' rel='noreferrer'>
       Agenda
      </a>
    )
  }

  return ""
}

const renderCalendar = (props) => {
  
  return ""
  /*const startDay=props.row.DateSession;
  const startTime=props.row.TimeSession        
  let startSession=startDay.split("/").reverse().join("-")
  startSession=startSession+"T"+startTime+"+03:00"

  const endDay=props.row.EndDaySession;
  const endTime=props.row.EndTimeSession;
  let endSession=endDay.split("/").reverse().join("-")
  endSession=endSession+"T"+endTime+"+03:00"
 

 const event = {
   title: "[PP-22] "+props.row.MonitorTitle,
   description: props.row.MonitorTitle,
   startTime: startSession,
   endTime: endSession,
   location:props.row.RoomName
   }

 //console.log(event)


  return props.formattedValue ? (
    <div className="calendar-div">
<ICalendarLink event={event}> <FontAwesomeIcon icon={faCalendar} /></ICalendarLink>

    </div>

  ) : (
    <div className="fake-avatar">
      <FontAwesomeIcon icon={faUser} />
    </div>
  );*/
};
export const ColumnsDailySchedule = [
  { field: 'MeetingType', headerName: 'Type', width: 200 },
  { field: 'MonitorTitle', headerName: 'Title', width: 410 },
  { field: 'MeetingGroup', headerName: 'Committee', width: 100 },
  { field: 'DateSession', headerName: 'Date', width: 120 },
  { field: 'TimeSession', headerName: 'Time', width: 70 },
  { field: 'RoomName', headerName: 'Venue', width: 180 },
  { field: 'DocumentNumber', headerName: 'Doc.', width: 100, renderCell: renderAgenda, },
  {
    field: 'CalendarDate',
    headerName: '',
    width: 0,
    renderCell: renderCalendar,
    hide:true,
  }
];

